import { IsNotEmpty, IsString } from 'class-validator';

export class RefreshAccessTokenPayload {
  @IsString()
  @IsNotEmpty()
  refreshToken: string;
}
